export default "__VITE_ASSET__BlZjd_3x__"